export const DRAWER_MOBILE_VIEW = {
  payWith: 'Pay with',
};
